import { Fragment, useEffect, useRef, useState } from 'react'
import HttpService from '../services/HttpService'
import { Badge, Button, Card, EmptyState, Field, KebabMenu, Modal, Page, Select, inputClass } from './ui'

export default function Usuarios(props) {
    const [open, setOpen] = useState(false)
    const [id, setId] = useState('')
    const [correo, setCorreo] = useState('')
    const [nombre, setNombre] = useState('')
    const [apellidos, setApellidos] = useState('')
    const [usuarios, setUsuarios] = useState([])
    const [rolSelected, setRolSelected] = useState({})
    const [roles] = useState([
        { nombre: 'Usuario', id: 'user' },
        { nombre: 'Administrador', id: 'admin' },
    ])
    const [modalTitle, setModalTitle] = useState()
    const [validateRolError, setValidateRolError] = useState()
    const [validateNombreError, setValidateNombreError] = useState()
    const [validateCorreoError, setValidateCorreoError] = useState()
    const [validateApellidosError, setValidateApellidosError] = useState()
    const validForm = useRef(true)
    const creating = useRef(true)

    useEffect(() => {
        props.handleTitulo('Usuarios')
        getUsuarios()
    }, [])

    const getUsuarios = () => {
        HttpService.getAxiosClient().get('/usuarios').then((res) => setUsuarios(res.data))
    }

    const handleRolSelected = (rol) => {
        setRolSelected(rol)
        setValidateRolError(null)
    }

    const handleCorreo = (correo) => {
        setCorreo(correo)
        setValidateCorreoError(null)
    }

    const handleNombre = (nombre) => {
        setNombre(nombre)
        setValidateNombreError(null)
    }

    const handleApellidos = (apellidos) => {
        setApellidos(apellidos)
        setValidateApellidosError(null)
    }

    const guardarClabe = () => {
        validateForm()
        if (validForm.current) {
            if (creating.current) {
                HttpService.getAxiosClient()
                    .post('/cuentas', {})
                    .then(() => {
                        getUsuarios()
                        setOpen(false)
                    })
            } else {
                HttpService.getAxiosClient()
                    .post(`/cuentas/${id}`, {})
                    .then(() => {
                        getUsuarios()
                        setOpen(false)
                    })
            }
        }
    }

    const validateForm = () => {
        validForm.current = true
    }

    const editar = (usuario) => {
        setOpen(true)
        creating.current = false
        setModalTitle('Editar usuario')
        setId(usuario.id)
        setCorreo(usuario.correo)
        setNombre(usuario.nombre)
        setApellidos(usuario.apellidos)
    }

    return (
        <Page
            description="Personas con acceso al panel de tu empresa."
            actions={
                <Button
                    onClick={() => {
                        creating.current = true
                        setOpen(true)
                        setModalTitle('Agregar usuario')
                        setCorreo('')
                        setNombre('')
                        setApellidos('')
                        setRolSelected({})
                    }}
                >
                    Nuevo usuario
                </Button>
            }
        >
            {usuarios.length === 0 ? (
                <EmptyState title="No hay usuarios" description="Agrega integrantes del equipo." />
            ) : (
                <ul className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {usuarios.map((usuario) => (
                        <li key={usuario.id}>
                            <Card>
                                <div className="flex items-start justify-between border-b border-slate-100 px-5 py-4">
                                    <div>
                                        <p className="text-sm font-semibold text-slate-900">{usuario.username}</p>
                                        <p className="text-xs text-slate-500">{usuario.correo || usuario.email}</p>
                                    </div>
                                    <KebabMenu
                                        items={[
                                            { label: 'Editar', onClick: () => editar(usuario) },
                                            { label: 'Eliminar', onClick: () => {}, danger: true },
                                        ]}
                                    />
                                </div>
                                <div className="space-y-2 px-5 py-4 text-sm">
                                    <p><span className="text-slate-500">Nombre</span> <span className="ml-2 text-slate-900">{usuario.nombre} {usuario.apellidos}</span></p>
                                    <p>
                                        <span className="text-slate-500">Rol</span>{' '}
                                        <span className="ml-2"><Badge tone={usuario.rol === 'admin' ? 'success' : 'neutral'}>{usuario.rol}</Badge></span>
                                    </p>
                                </div>
                            </Card>
                        </li>
                    ))}
                </ul>
            )}

            <Modal
                open={open}
                onClose={setOpen}
                title={modalTitle}
                footer={
                    <Fragment>
                        <Button variant="secondary" onClick={() => setOpen(false)}>Cancelar</Button>
                        <Button onClick={guardarClabe}>Guardar</Button>
                    </Fragment>
                }
            >
                <Field label="Correo" error={validateCorreoError}>
                    <input type="text" value={correo} onChange={(e) => handleCorreo(e.target.value)} className={inputClass} />
                </Field>
                <Field label="Nombre" error={validateNombreError}>
                    <input type="text" value={nombre} onChange={(e) => handleNombre(e.target.value)} className={inputClass} />
                </Field>
                <Field label="Apellidos" error={validateApellidosError}>
                    <input type="text" value={apellidos} onChange={(e) => handleApellidos(e.target.value)} className={inputClass} />
                </Field>
                <Field label="Rol" error={validateRolError}>
                    <Select value={rolSelected} onChange={handleRolSelected} options={roles} />
                </Field>
            </Modal>
        </Page>
    )
}
